@file:OptIn(InternalResourceApi::class)

package dev.wyns.ventrova.resources

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.LanguageQualifier
import org.jetbrains.compose.resources.ResourceContentHash
import org.jetbrains.compose.resources.ResourceItem
import org.jetbrains.compose.resources.StringResource

private const val MD: String = "composeResources/dev.wyns.ventrova.resources/"

@delegate:ResourceContentHash(-286_255_541)
internal val Res.string.menu_title_vegan: StringResource by lazy {
      StringResource("string:menu_title_vegan", "menu_title_vegan", setOf(
        ResourceItem(setOf(LanguageQualifier("nl"), ), "${MD}values-nl/strings.commonMain.cvr", 5757, 40),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5609, 44),
      ))
    }

@delegate:ResourceContentHash(-1_476_891_215)
internal val Res.string.nearby_by_distance: StringResource by lazy {
      StringResource("string:nearby_by_distance", "nearby_by_distance", setOf(
        ResourceItem(setOf(LanguageQualifier("nl"), ), "${MD}values-nl/strings.commonMain.cvr", 5845, 42),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5709, 42),
      ))
    }

@delegate:ResourceContentHash(78_745_765)
internal val Res.string.nearby_nothing_found: StringResource by lazy {
      StringResource("string:nearby_nothing_found", "nearby_nothing_found", setOf(
        ResourceItem(setOf(LanguageQualifier("nl"), ), "${MD}values-nl/strings.commonMain.cvr", 5888, 72),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5752, 72),
      ))
    }

@delegate:ResourceContentHash(-1_821_907_083)
internal val Res.string.nearby_tab: StringResource by lazy {
      StringResource("string:nearby_tab", "nearby_tab", setOf(
        ResourceItem(setOf(LanguageQualifier("nl"), ), "${MD}values-nl/strings.commonMain.cvr", 5961, 46),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5825, 38),
      ))
    }

@delegate:ResourceContentHash(670_994_147)
internal val Res.string.nearby_title: StringResource by lazy {
      StringResource("string:nearby_title", "nearby_title", setOf(
        ResourceItem(setOf(LanguageQualifier("nl"), ), "${MD}values-nl/strings.commonMain.cvr", 6008, 36),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5864, 28),
      ))
    }

@delegate:ResourceContentHash(-5_011_209)
internal val Res.string.nearby_zoom_in: StringResource by lazy {
      StringResource("string:nearby_zoom_in", "nearby_zoom_in", setOf(
        ResourceItem(setOf(LanguageQualifier("nl"), ), "${MD}values-nl/strings.commonMain.cvr", 6045, 58),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5893, 54),
      ))
    }

@delegate:ResourceContentHash(129_359_782)
internal val Res.string.not_available_yet: StringResource by lazy {
      StringResource("string:not_available_yet", "not_available_yet", setOf(
        ResourceItem(setOf(LanguageQualifier("nl"), ), "${MD}values-nl/strings.commonMain.cvr", 6104, 53),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5948, 49),
      ))
    }

@delegate:ResourceContentHash(1_583_684_710)
internal val Res.string.onboarding_skip: StringResource by lazy {
      StringResource("string:onboarding_skip", "onboarding_skip", setOf(
        ResourceItem(setOf(LanguageQualifier("nl"), ), "${MD}values-nl/strings.commonMain.cvr", 6198, 59),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6042, 59),
      ))
    }

@delegate:ResourceContentHash(1_509_024_693)
internal val Res.string.onboarding_skip_web: StringResource by lazy {
      StringResource("string:onboarding_skip_web", "onboarding_skip_web", setOf(
        ResourceItem(setOf(LanguageQualifier("nl"), ), "${MD}values-nl/strings.commonMain.cvr", 6158, 39),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5998, 43),
      ))
    }

@delegate:ResourceContentHash(-1_056_970_971)
internal val Res.string.onboarding_tagline: StringResource by lazy {
      StringResource("string:onboarding_tagline", "onboarding_tagline", setOf(
        ResourceItem(setOf(LanguageQualifier("nl"), ), "${MD}values-nl/strings.commonMain.cvr", 6258, 110),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6102, 106),
      ))
    }

@delegate:ResourceContentHash(-363_612_126)
internal val Res.string.onboarding_use_location: StringResource by lazy {
      StringResource("string:onboarding_use_location", "onboarding_use_location", setOf(
        ResourceItem(setOf(LanguageQualifier("nl"), ), "${MD}values-nl/strings.commonMain.cvr", 6433, 63),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6265, 63),
      ))
    }

@delegate:ResourceContentHash(1_334_532_665)
internal val Res.string.onboarding_use_location_web: StringResource by lazy {
      StringResource("string:onboarding_use_location_web", "onboarding_use_location_web", setOf(
        ResourceItem(setOf(LanguageQualifier("nl"), ), "${MD}values-nl/strings.commonMain.cvr", 6369, 63),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6209, 55),
      ))
    }

@delegate:ResourceContentHash(133_463_119)
internal val Res.string.opening_hours: StringResource by lazy {
      StringResource("string:opening_hours", "opening_hours", setOf(
        ResourceItem(setOf(LanguageQualifier("nl"), ), "${MD}values-nl/strings.commonMain.cvr", 6582, 37),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6410, 41),
      ))
    }

@delegate:ResourceContentHash(-1_070_122_819)
internal val Res.string.opening_hours_closed: StringResource by lazy {
      StringResource("string:opening_hours_closed", "opening_hours_closed", setOf(
        ResourceItem(setOf(LanguageQualifier("nl"), ), "${MD}values-nl/strings.commonMain.cvr", 6497, 40),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6329, 36),
      ))
    }

@delegate:ResourceContentHash(1_877_793_525)
internal val Res.string.opening_hours_today: StringResource by lazy {
      StringResource("string:opening_hours_today", "opening_hours_today", setOf(
        ResourceItem(setOf(LanguageQualifier("nl"), ), "${MD}values-nl/strings.commonMain.cvr", 6538, 43),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6366, 43),
      ))
    }

@delegate:ResourceContentHash(-1_772_382_273)
internal val Res.string.profile: StringResource by lazy {
      StringResource("string:profile", "profile", setOf(
        ResourceItem(setOf(LanguageQualifier("nl"), ), "${MD}values-nl/strings.commonMain.cvr", 6960, 27),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6788, 27),
      ))
    }

@delegate:ResourceContentHash(1_483_107_524)
internal val Res.string.profile_about: StringResource by lazy {
      StringResource("string:profile_about", "profile_about", setOf(
        ResourceItem(setOf(LanguageQualifier("nl"), ), "${MD}values-nl/strings.commonMain.cvr", 6727, 41),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6559, 41),
      ))
    }

@delegate:ResourceContentHash(1_587_601_573)
internal val Res.string.profile_about_body: StringResource by lazy {
      StringResource("string:profile_about_body", "profile_about_body", setOf(
        ResourceItem(setOf(LanguageQualifier("nl"), ), "${MD}values-nl/strings.commonMain.cvr", 6620, 106),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6452, 106),
      ))
    }

@delegate:ResourceContentHash(2_120_652_128)
internal val Res.string.profile_community: StringResource by lazy {
      StringResource("string:profile_community", "profile_community", setOf(
        ResourceItem(setOf(LanguageQualifier("nl"), ), "${MD}values-nl/strings.commonMain.cvr", 6769, 37),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6601, 37),
      ))
    }

@delegate:ResourceContentHash(-551_369_027)
internal val Res.string.profile_default_filter: StringResource by lazy {
      StringResource("string:profile_default_filter", "profile_default_filter", setOf(
        ResourceItem(setOf(LanguageQualifier("nl"), ), "${MD}values-nl/strings.commonMain.cvr", 6807, 50),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6639, 50),
      ))
    }

@delegate:ResourceContentHash(1_608_287_242)
internal val Res.string.profile_help_map_grow: StringResource by lazy {
      StringResource("string:profile_help_map_grow", "profile_help_map_grow", setOf(
        ResourceItem(setOf(LanguageQualifier("nl"), ), "${MD}values-nl/strings.commonMain.cvr", 6858, 57),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6690, 53),
      ))
    }

@delegate:ResourceContentHash(670_456_602)
internal val Res.string.profile_preferences: StringResource by lazy {
      StringResource("string:profile_preferences", "profile_preferences", setOf(
        ResourceItem(setOf(LanguageQualifier("nl"), ), "${MD}values-nl/strings.commonMain.cvr", 6916, 43),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6744, 43),
      ))
    }

@delegate:ResourceContentHash(223_354_125)
internal val Res.string.report_action: StringResource by lazy {
      StringResource("string:report_action", "report_action", setOf(
        ResourceItem(setOf(LanguageQualifier("nl"), ), "${MD}values-nl/strings.commonMain.cvr", 6988, 45),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6816, 41),
      ))
    }

@delegate:ResourceContentHash(-51_431_294)
internal val Res.string.report_question: StringResource by lazy {
      StringResource("string:report_question", "report_question", setOf(
        ResourceItem(setOf(LanguageQualifier("nl"), ), "${MD}values-nl/strings.commonMain.cvr", 7034, 51),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6858, 47),
      ))
    }

@delegate:ResourceContentHash(-1_903_965_535)
internal val Res.string.search: StringResource by lazy {
      StringResource("string:search", "search", setOf(
        ResourceItem(setOf(LanguageQualifier("nl"), ), "${MD}values-nl/strings.commonMain.cvr", 7568, 22),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7376, 22),
      ))
    }

@delegate:ResourceContentHash(-384_485_891)
internal val Res.string.search_in_app: StringResource by lazy {
      StringResource("string:search_in_app", "search_in_app", setOf(
        ResourceItem(setOf(LanguageQualifier("nl"), ), "${MD}values-nl/strings.commonMain.cvr", 7086, 45),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6906, 41),
      ))
    }

@delegate:ResourceContentHash(336_486_597)
internal val Res.string.search_no_results: StringResource by lazy {
      StringResource("string:search_no_results", "search_no_results", setOf(
        ResourceItem(setOf(LanguageQualifier("nl"), ), "${MD}values-nl/strings.commonMain.cvr", 7218, 73),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7022, 61),
      ))
    }

@delegate:ResourceContentHash(-1_644_357_092)
internal val Res.string.search_no_results_web: StringResource by lazy {
      StringResource("string:search_no_results_web", "search_no_results_web", setOf(
        ResourceItem(setOf(LanguageQualifier("nl"), ), "${MD}values-nl/strings.commonMain.cvr", 7132, 85),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6948, 73),
      ))
    }

@delegate:ResourceContentHash(-617_043_588)
internal val Res.string.search_placeholder: StringResource by lazy {
      StringResource("string:search_placeholder", "search_placeholder", setOf(
        ResourceItem(setOf(LanguageQualifier("nl"), ), "${MD}values-nl/strings.commonMain.cvr", 7368, 58),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7160, 58),
      ))
    }

@delegate:ResourceContentHash(2_033_867_451)
internal val Res.string.search_placeholder_long: StringResource by lazy {
      StringResource("string:search_placeholder_long", "search_placeholder_long", setOf(
        ResourceItem(setOf(LanguageQualifier("nl"), ), "${MD}values-nl/strings.commonMain.cvr", 7292, 75),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7084, 75),
      ))
    }

@delegate:ResourceContentHash(1_315_921_753)
internal val Res.string.search_popular_title: StringResource by lazy {
      StringResource("string:search_popular_title", "search_popular_title", setOf(
        ResourceItem(setOf(LanguageQualifier("nl"), ), "${MD}values-nl/strings.commonMain.cvr", 7427, 40),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7219, 40),
      ))
    }

@delegate:ResourceContentHash(-112_410_817)
internal val Res.string.search_suggest_one: StringResource by lazy {
      StringResource("string:search_suggest_one", "search_suggest_one", setOf(
        ResourceItem(setOf(LanguageQualifier("nl"), ), "${MD}values-nl/strings.commonMain.cvr", 7468, 38),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7260, 42),
      ))
    }

@delegate:ResourceContentHash(949_618_324)
internal val Res.string.search_suggestions_title: StringResource by lazy {
      StringResource("string:search_suggestions_title", "search_suggestions_title", setOf(
        ResourceItem(setOf(LanguageQualifier("nl"), ), "${MD}values-nl/strings.commonMain.cvr", 7507, 60),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7303, 72),
      ))
    }

@delegate:ResourceContentHash(-3_939_244)
internal val Res.string.status_always_open: StringResource by lazy {
      StringResource("string:status_always_open", "status_always_open", setOf(
        ResourceItem(setOf(LanguageQualifier("nl"), ), "${MD}values-nl/strings.commonMain.cvr", 7591, 38),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7399, 38),
      ))
    }

@delegate:ResourceContentHash(219_520_445)
internal val Res.string.status_closed: StringResource by lazy {
      StringResource("string:status_closed", "status_closed", setOf(
        ResourceItem(setOf(LanguageQualifier("nl"), ), "${MD}values-nl/strings.commonMain.cvr", 7666, 33),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7474, 29),
      ))
    }

@delegate:ResourceContentHash(1_085_298_429)
internal val Res.string.status_closed_short: StringResource by lazy {
      StringResource("string:status_closed_short", "status_closed_short", setOf(
        ResourceItem(setOf(LanguageQualifier("nl"), ), "${MD}values-nl/strings.commonMain.cvr", 7630, 35),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7438, 35),
      ))
    }

@delegate:ResourceContentHash(-22_474_019)
internal val Res.string.status_closes_at: StringResource by lazy {
      StringResource("string:status_closes_at", "status_closes_at", setOf(
        ResourceItem(setOf(LanguageQualifier("nl"), ), "${MD}values-nl/strings.commonMain.cvr", 7700, 44),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7504, 44),
      ))
    }

@delegate:ResourceContentHash(-1_703_826_328)
internal val Res.string.status_hours_unknown: StringResource by lazy {
      StringResource("string:status_hours_unknown", "status_hours_unknown", setOf(
        ResourceItem(setOf(LanguageQualifier("nl"), ), "${MD}values-nl/strings.commonMain.cvr", 7745, 48),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7549, 48),
      ))
    }

@delegate:ResourceContentHash(-804_510_272)
internal val Res.string.status_open: StringResource by lazy {
      StringResource("string:status_open", "status_open", setOf(
        ResourceItem(setOf(LanguageQualifier("nl"), ), "${MD}values-nl/strings.commonMain.cvr", 7950, 27),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7758, 27),
      ))
    }

@delegate:ResourceContentHash(-567_034_926)
internal val Res.string.status_opens_at: StringResource by lazy {
      StringResource("string:status_opens_at", "status_opens_at", setOf(
        ResourceItem(setOf(LanguageQualifier("nl"), ), "${MD}values-nl/strings.commonMain.cvr", 7794, 43),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7598, 43),
      ))
    }

@delegate:ResourceContentHash(850_075_140)
internal val Res.string.status_opens_on_at: StringResource by lazy {
      StringResource("string:status_opens_on_at", "status_opens_on_at", setOf(
        ResourceItem(setOf(LanguageQualifier("nl"), ), "${MD}values-nl/strings.commonMain.cvr", 7838, 50),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7642, 50),
      ))
    }

@delegate:ResourceContentHash(-1_240_664_096)
internal val Res.string.status_opens_tomorrow_at: StringResource by lazy {
      StringResource("string:status_opens_tomorrow_at", "status_opens_tomorrow_at", setOf(
        ResourceItem(setOf(LanguageQualifier("nl"), ), "${MD}values-nl/strings.commonMain.cvr", 7889, 60),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7693, 64),
      ))
    }

@delegate:ResourceContentHash(1_526_970_741)
internal val Res.string.suggest_address: StringResource by lazy {
      StringResource("string:suggest_address", "suggest_address", setOf(
        ResourceItem(setOf(LanguageQualifier("nl"), ), "${MD}values-nl/strings.commonMain.cvr", 8076, 43),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7880, 43),
      ))
    }

@delegate:ResourceContentHash(-1_009_524_916)
internal val Res.string.suggest_address_placeholder: StringResource by lazy {
      StringResource("string:suggest_address_placeholder", "suggest_address_placeholder", setOf(
        ResourceItem(setOf(LanguageQualifier("nl"), ), "${MD}values-nl/strings.commonMain.cvr", 7978, 59),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7786, 51),
      ))
    }

@delegate:ResourceContentHash(-1_990_905_242)
internal val Res.string.suggest_address_short: StringResource by lazy {
      StringResource("string:suggest_address_short", "suggest_address_short", setOf(
        ResourceItem(setOf(LanguageQualifier("nl"), ), "${MD}values-nl/strings.commonMain.cvr", 8038, 37),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7838, 41),
      ))
    }

@delegate:ResourceContentHash(-6_968_885)
internal val Res.string.suggest_back_to_map: StringResource by lazy {
      StringResource("string:suggest_back_to_map", "suggest_back_to_map", setOf(
        ResourceItem(setOf(LanguageQualifier("nl"), ), "${MD}values-nl/strings.commonMain.cvr", 8120, 55),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7924, 47),
      ))
    }

@delegate:ResourceContentHash(9_966_759)
internal val Res.string.suggest_cancel: StringResource by lazy {
      StringResource("string:suggest_cancel", "suggest_cancel", setOf(
        ResourceItem(setOf(LanguageQualifier("nl"), ), "${MD}values-nl/strings.commonMain.cvr", 8176, 34),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7972, 30),
      ))
    }

@delegate:ResourceContentHash(947_369_670)
internal val Res.string.suggest_done: StringResource by lazy {
      StringResource("string:suggest_done", "suggest_done", setOf(
        ResourceItem(setOf(LanguageQualifier("nl"), ), "${MD}values-nl/strings.commonMain.cvr", 8211, 28),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 8003, 28),
      ))
    }

@delegate:ResourceContentHash(-224_502_042)
internal val Res.string.suggest_error: StringResource by lazy {
      StringResource("string:suggest_error", "suggest_error", setOf(
        ResourceItem(setOf(LanguageQualifier("nl"), ), "${MD}values-nl/strings.commonMain.cvr", 8240, 89),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 8032, 77),
      ))
    }

@delegate:ResourceContentHash(1_333_738_866)
internal val Res.string.suggest_intro: StringResource by lazy {
      StringResource("string:suggest_intro", "suggest_intro", setOf(
        ResourceItem(setOf(LanguageQualifier("nl"), ), "${MD}values-nl/strings.commonMain.cvr", 8330, 109),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 8110, 109),
      ))
    }

@delegate:ResourceContentHash(-473_665_422)
internal val Res.string.suggest_name: StringResource by lazy {
      StringResource("string:suggest_name", "suggest_name", setOf(
        ResourceItem(setOf(LanguageQualifier("nl"), ), "${MD}values-nl/strings.commonMain.cvr", 8532, 44),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 8312, 44),
      ))
    }

@delegate:ResourceContentHash(296_731_436)
internal val Res.string.suggest_name_placeholder: StringResource by lazy {
      StringResource("string:suggest_name_placeholder", "suggest_name_placeholder", setOf(
        ResourceItem(setOf(LanguageQualifier("nl"), ), "${MD}values-nl/strings.commonMain.cvr", 8440, 56),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 8220, 56),
      ))
    }

@delegate:ResourceContentHash(691_368_020)
internal val Res.string.suggest_name_short: StringResource by lazy {
      StringResource("string:suggest_name_short", "suggest_name_short", setOf(
        ResourceItem(setOf(LanguageQualifier("nl"), ), "${MD}values-nl/strings.commonMain.cvr", 8497, 34),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 8277, 34),
      ))
    }

@delegate:ResourceContentHash(-1_389_182_838)
internal val Res.string.suggest_note_placeholder: StringResource by lazy {
      StringResource("string:suggest_note_placeholder", "suggest_note_placeholder", setOf(
        ResourceItem(setOf(LanguageQualifier("nl"), ), "${MD}values-nl/strings.commonMain.cvr", 8577, 76),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 8357, 80),
      ))
    }

@delegate:ResourceContentHash(948_381_898)
internal val Res.string.suggest_optional: StringResource by lazy {
      StringResource("string:suggest_optional", "suggest_optional", setOf(
        ResourceItem(setOf(LanguageQualifier("nl"), ), "${MD}values-nl/strings.commonMain.cvr", 8654, 36),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 8438, 36),
      ))
    }

@delegate:ResourceContentHash(1_218_108_779)
internal val Res.string.suggest_place: StringResource by lazy {
      StringResource("string:suggest_place", "suggest_place", setOf(
        ResourceItem(setOf(LanguageQualifier("nl"), ), "${MD}values-nl/strings.commonMain.cvr", 8691, 45),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 8475, 41),
      ))
    }

@delegate:ResourceContentHash(-1_583_180_302)
internal val Res.string.suggest_send: StringResource by lazy {
      StringResource("string:suggest_send", "suggest_send", setOf(
        ResourceItem(setOf(LanguageQualifier("nl"), ), "${MD}values-nl/strings.commonMain.cvr", 8787, 32),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 8563, 28),
      ))
    }

@delegate:ResourceContentHash(-1_806_030_181)
internal val Res.string.suggest_send_long: StringResource by lazy {
      StringResource("string:suggest_send_long", "suggest_send_long", setOf(
        ResourceItem(setOf(LanguageQualifier("nl"), ), "${MD}values-nl/strings.commonMain.cvr", 8737, 49),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 8517, 45),
      ))
    }

@delegate:ResourceContentHash(1_828_181_040)
internal val Res.string.suggest_short: StringResource by lazy {
      StringResource("string:suggest_short", "suggest_short", setOf(
        ResourceItem(setOf(LanguageQualifier("nl"), ), "${MD}values-nl/strings.commonMain.cvr", 8820, 37),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 8592, 33),
      ))
    }

@delegate:ResourceContentHash(-460_888_601)
internal val Res.string.suggest_thanks: StringResource by lazy {
      StringResource("string:suggest_thanks", "suggest_thanks", setOf(
        ResourceItem(setOf(LanguageQualifier("nl"), ), "${MD}values-nl/strings.commonMain.cvr", 9052, 34),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 8840, 34),
      ))
    }

@delegate:ResourceContentHash(-425_966_432)
internal val Res.string.suggest_thanks_body: StringResource by lazy {
      StringResource("string:suggest_thanks_body", "suggest_thanks_body", setOf(
        ResourceItem(setOf(LanguageQualifier("nl"), ), "${MD}values-nl/strings.commonMain.cvr", 8932, 119),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 8708, 131),
      ))
    }

@delegate:ResourceContentHash(-1_816_704_368)
internal val Res.string.suggest_thanks_body_short: StringResource by lazy {
      StringResource("string:suggest_thanks_body_short", "suggest_thanks_body_short", setOf(
        ResourceItem(setOf(LanguageQualifier("nl"), ), "${MD}values-nl/strings.commonMain.cvr", 8858, 73),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 8626, 81),
      ))
    }

@delegate:ResourceContentHash(-486_197_622)
internal val Res.string.suggest_what_is_vegan: StringResource by lazy {
      StringResource("string:suggest_what_is_vegan", "suggest_what_is_vegan", setOf(
        ResourceItem(setOf(LanguageQualifier("nl"), ), "${MD}values-nl/strings.commonMain.cvr", 9147, 69),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 8931, 65),
      ))
    }

@delegate:ResourceContentHash(-1_507_162_902)
internal val Res.string.suggest_what_is_vegan_short: StringResource by lazy {
      StringResource("string:suggest_what_is_vegan_short", "suggest_what_is_vegan_short", setOf(
        ResourceItem(setOf(LanguageQualifier("nl"), ), "${MD}values-nl/strings.commonMain.cvr", 9087, 59),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 8875, 55),
      ))
    }

@delegate:ResourceContentHash(1_193_166_890)
internal val Res.string.tab_favorites: StringResource by lazy {
      StringResource("string:tab_favorites", "tab_favorites", setOf(
        ResourceItem(setOf(LanguageQualifier("nl"), ), "${MD}values-nl/strings.commonMain.cvr", 9217, 37),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 8997, 33),
      ))
    }

@delegate:ResourceContentHash(-1_973_107_940)
internal val Res.string.tab_map: StringResource by lazy {
      StringResource("string:tab_map", "tab_map", setOf(
        ResourceItem(setOf(LanguageQualifier("nl"), ), "${MD}values-nl/strings.commonMain.cvr", 9255, 23),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 9031, 19),
      ))
    }

@delegate:ResourceContentHash(-1_772_382_273)
internal val Res.string.tab_profile: StringResource by lazy {
      StringResource("string:tab_profile", "tab_profile", setOf(
        ResourceItem(setOf(LanguageQualifier("nl"), ), "${MD}values-nl/strings.commonMain.cvr", 9279, 31),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 9051, 31),
      ))
    }

@delegate:ResourceContentHash(-1_903_965_535)
internal val Res.string.tab_search: StringResource by lazy {
      StringResource("string:tab_search", "tab_search", setOf(
        ResourceItem(setOf(LanguageQualifier("nl"), ), "${MD}values-nl/strings.commonMain.cvr", 9311, 26),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 9083, 26),
      ))
    }

@delegate:ResourceContentHash(749_769_024)
internal val Res.string.walk_minutes: StringResource by lazy {
      StringResource("string:walk_minutes", "walk_minutes", setOf(
        ResourceItem(setOf(LanguageQualifier("nl"), ), "${MD}values-nl/strings.commonMain.cvr", 9388, 32),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 9156, 32),
      ))
    }

@delegate:ResourceContentHash(-1_720_465_500)
internal val Res.string.walk_minutes_long: StringResource by lazy {
      StringResource("string:walk_minutes_long", "walk_minutes_long", setOf(
        ResourceItem(setOf(LanguageQualifier("nl"), ), "${MD}values-nl/strings.commonMain.cvr", 9338, 49),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 9110, 45),
      ))
    }

@delegate:ResourceContentHash(-1_792_418_411)
internal val Res.string.your_location: StringResource by lazy {
      StringResource("string:your_location", "your_location", setOf(
        ResourceItem(setOf(LanguageQualifier("nl"), ), "${MD}values-nl/strings.commonMain.cvr", 9421, 37),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 9189, 41),
      ))
    }

@InternalResourceApi
internal fun _collectCommonMainString1Resources(map: MutableMap<String, StringResource>) {
  map.put("menu_title_vegan", Res.string.menu_title_vegan)
  map.put("nearby_by_distance", Res.string.nearby_by_distance)
  map.put("nearby_nothing_found", Res.string.nearby_nothing_found)
  map.put("nearby_tab", Res.string.nearby_tab)
  map.put("nearby_title", Res.string.nearby_title)
  map.put("nearby_zoom_in", Res.string.nearby_zoom_in)
  map.put("not_available_yet", Res.string.not_available_yet)
  map.put("onboarding_skip", Res.string.onboarding_skip)
  map.put("onboarding_skip_web", Res.string.onboarding_skip_web)
  map.put("onboarding_tagline", Res.string.onboarding_tagline)
  map.put("onboarding_use_location", Res.string.onboarding_use_location)
  map.put("onboarding_use_location_web", Res.string.onboarding_use_location_web)
  map.put("opening_hours", Res.string.opening_hours)
  map.put("opening_hours_closed", Res.string.opening_hours_closed)
  map.put("opening_hours_today", Res.string.opening_hours_today)
  map.put("profile", Res.string.profile)
  map.put("profile_about", Res.string.profile_about)
  map.put("profile_about_body", Res.string.profile_about_body)
  map.put("profile_community", Res.string.profile_community)
  map.put("profile_default_filter", Res.string.profile_default_filter)
  map.put("profile_help_map_grow", Res.string.profile_help_map_grow)
  map.put("profile_preferences", Res.string.profile_preferences)
  map.put("report_action", Res.string.report_action)
  map.put("report_question", Res.string.report_question)
  map.put("search", Res.string.search)
  map.put("search_in_app", Res.string.search_in_app)
  map.put("search_no_results", Res.string.search_no_results)
  map.put("search_no_results_web", Res.string.search_no_results_web)
  map.put("search_placeholder", Res.string.search_placeholder)
  map.put("search_placeholder_long", Res.string.search_placeholder_long)
  map.put("search_popular_title", Res.string.search_popular_title)
  map.put("search_suggest_one", Res.string.search_suggest_one)
  map.put("search_suggestions_title", Res.string.search_suggestions_title)
  map.put("status_always_open", Res.string.status_always_open)
  map.put("status_closed", Res.string.status_closed)
  map.put("status_closed_short", Res.string.status_closed_short)
  map.put("status_closes_at", Res.string.status_closes_at)
  map.put("status_hours_unknown", Res.string.status_hours_unknown)
  map.put("status_open", Res.string.status_open)
  map.put("status_opens_at", Res.string.status_opens_at)
  map.put("status_opens_on_at", Res.string.status_opens_on_at)
  map.put("status_opens_tomorrow_at", Res.string.status_opens_tomorrow_at)
  map.put("suggest_address", Res.string.suggest_address)
  map.put("suggest_address_placeholder", Res.string.suggest_address_placeholder)
  map.put("suggest_address_short", Res.string.suggest_address_short)
  map.put("suggest_back_to_map", Res.string.suggest_back_to_map)
  map.put("suggest_cancel", Res.string.suggest_cancel)
  map.put("suggest_done", Res.string.suggest_done)
  map.put("suggest_error", Res.string.suggest_error)
  map.put("suggest_intro", Res.string.suggest_intro)
  map.put("suggest_name", Res.string.suggest_name)
  map.put("suggest_name_placeholder", Res.string.suggest_name_placeholder)
  map.put("suggest_name_short", Res.string.suggest_name_short)
  map.put("suggest_note_placeholder", Res.string.suggest_note_placeholder)
  map.put("suggest_optional", Res.string.suggest_optional)
  map.put("suggest_place", Res.string.suggest_place)
  map.put("suggest_send", Res.string.suggest_send)
  map.put("suggest_send_long", Res.string.suggest_send_long)
  map.put("suggest_short", Res.string.suggest_short)
  map.put("suggest_thanks", Res.string.suggest_thanks)
  map.put("suggest_thanks_body", Res.string.suggest_thanks_body)
  map.put("suggest_thanks_body_short", Res.string.suggest_thanks_body_short)
  map.put("suggest_what_is_vegan", Res.string.suggest_what_is_vegan)
  map.put("suggest_what_is_vegan_short", Res.string.suggest_what_is_vegan_short)
  map.put("tab_favorites", Res.string.tab_favorites)
  map.put("tab_map", Res.string.tab_map)
  map.put("tab_profile", Res.string.tab_profile)
  map.put("tab_search", Res.string.tab_search)
  map.put("walk_minutes", Res.string.walk_minutes)
  map.put("walk_minutes_long", Res.string.walk_minutes_long)
  map.put("your_location", Res.string.your_location)
}
